var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoNotify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.408 63.8495L72.0743 73.1833M81.408 73.183L72.0743 63.8493M47.9255 63.8495L38.5917 73.1833M47.9255 73.183L38.5917 63.8493M69.2208 91.8041C64.1283 86.7116 55.8717 86.7116 50.7795 91.8041M22.9514 25.442H25.3859M42.187 25.442H44.6215M61.4227 25.442H63.8571M115.312 75.7724V44.1067H4.6875V99.1591C4.6875 106.926 10.9835 113.222 18.75 113.222H101.25C108.999 113.222 115.284 106.953 115.311 99.2099M115.312 20.8398C115.312 13.0734 109.016 6.77734 101.25 6.77734H18.75C10.9835 6.77734 4.6875 13.0734 4.6875 20.8398V44.1069H115.312V20.8398Z",
    stroke: "#00ACB9",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotify);
export default __webpack_public_path__ + "static/media/no_notify.ee3b4bed7c5da9e857648c9e74884aaf.svg";
export { ForwardRef as ReactComponent };